module.exports = __webpack_public_path__ + "images/emoji/tv.e1c6922aed32358dc028.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tv.png
// module id = 8bZ6
// module chunks = 2